package com.github.jangalinski.tabweb._foundation.compose

import androidx.compose.runtime.Composable
import com.github.jangalinski.tabweb._foundation.Url
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.A

/**
 * Internal DOM adapter for an anchor with Kobweb modifier support.
 *
 * @param href destination URL written to the anchor's `href` attribute.
 * @param modifier attributes, classes, and styles applied to the anchor.
 * @param onClickAction optional click handler; when provided, browser navigation is prevented.
 * @param content composable anchor content.
 */
@Composable
fun KAnchor(
  href: String,
  modifier: Modifier = Modifier,
  onClickAction: (() -> Unit)? = null,
  content: @Composable () -> Unit
) {
  A(href = href, attrs = modifier.toAttrs {
    onClickAction?.let { handler ->
      onClick {
        it.preventDefault()
        handler()
      }
    }
  }) {
    content()
  }
}

@Composable
fun KAnchor(
  href: Url,
  modifier: Modifier = Modifier,
  onClickAction: (() -> Unit)? = null,
  content: @Composable () -> Unit
) = KAnchor(href = href.get(), modifier = modifier, onClickAction = onClickAction, content = content)
